import React, { useEffect, useState } from 'react';
import ActivityCard from '../components/layout/ActivityCard';
import DealCard from './DealCard';
import Layout from '../components/layout/AppLayout';
import Header from '../../shared/components/layout/Header';
import NoDataFound from '../components/layout/NoDataFound';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';

const DealsList = ({ salesId, dealData, isLoadingDeals, onDealUpdate }) => {
  const userId = Cookies.get('userId');
  const [filteredData, setFilteredData] = useState([]);
  const [dealId, setDealId] = useState(null);
  
  // Track page view
  useEffect(() => {
    mixpanel.track('Deals List Viewed', {
      user_id: userId,
      timestamp: new Date().toISOString()
    });
  }, [userId]);

  useEffect(() => {
    if (dealData) {
      // If dealData is passed as prop, use it directly
      setFilteredData([dealData]);
      setDealId(dealData?.id);
    }
  }, [dealData]);

  if (isLoadingDeals) {
    return <div>Loading...</div>;
  }

  return (
    <div className="flex flex-col bg-white shadow-lg rounded-lg mt-[0.5rem] w-[100%] mx-auto p-6">
      <span className="text-lg font-semibold">Stages</span>
      {filteredData?.[0]?.lead?.activities?.length > 0 ? (
        <div className="flex flex-col">
          <div className="w-full flex flex-col justify-between items-center gap-8 mt-10">
            {filteredData?.[0]?.lead?.activities?.map((item, index) => (
              <DealCard
                key={index}
                special={index === 0}
                data={item}
                dealId={dealId}
                allData={filteredData?.[0]}
                onSuccess={() => {
                  if (onDealUpdate) {
                    onDealUpdate();
                  }
                }}
              />
            ))}
          </div>
        </div>
      ) : (
        <NoDataFound disabledBtn screenHeight={true} />
      )}
    </div>
  );
};

export default DealsList;
